import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, Dimensions } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { ref } from '@dbk-legacy/muster/utils';
import capitalize from 'lodash/capitalize';
import Error from '../../../../../../src/components/common/error';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import AbbreviatedNotes from '../../../../../../src/components/common/abbreviated-notes';
import AssetHeader from './asset-header/asset-header';
import AssetPosition from './asset-position/asset-position-container';
import AssetPositionDetails from './asset-position-details/asset-position-details-container';
import ScrollableLayout from '../../../../../../src/components/common/scrollable-layout';
import AssetPositionModal from './asset-position-modal';
import SortingHeader from '../../../../../../src/components/common/sorting-header/sorting-header-container';
//import Pagination from '../../../../../../src/components/common/pagination';
import Pagination from '../../../../../../src/components/common/pagination/asset-pagination';
import NavigationBar from './navigation-bar-ch';
import { StickyContainer, Sticky } from 'react-sticky';
import AssetAccordion from '../../../../../../src/components/common/asset-accordion/asset-accordion.container';
import { ROUTES } from '../../../../../../src/constants'
// import  ErrorModal from '../../../../../../src/screens/trading/common/error-modal'

class Header extends PureComponent {
  render() {
    const { portfolio, ui, search, screen, i18n: { messages } } = this.props.inputs;
    const assetData = portfolio[this.props.assetCategory];
    const referenceCurrency = portfolio.referenceCurrency;
    const uiStatic = assetData.static;
    const uiSortingState = ui.state.portfolio[this.props.assetCategory];
    return (
      <div style={{ ...this.props.style, overflow: 'auto' }}>
        <SortingHeader
          currency={referenceCurrency}
          uiStatic={uiStatic}
          state={uiSortingState}
          screen={screen}
          messages={messages}
          enabled
          iconSortEnabled
        />
      </div>
    );
  }
}

export default function assetPositionsFactory({
  assetCategory,

  HeaderComponent = AssetHeader,
  SortingHeaderComponent = SortingHeader,
  RowComponent = AssetPosition,
  ExpandedRowComponent = AssetPositionDetails,
}) {

  let selectedFirstLevelAsset = "";
  const positionsProp = assetCategory === 'mmInstruments' ? 'positionsAlias' : 'positions';

  class AssetPositions extends PureComponent {
    constructor() {
      super();
      this.state = { activeItems: [], widthClassForZoom: false }
      this.handlePageChange = this.handlePageChange.bind(this);
      this.handleCtaClick = this.handleCtaClick.bind(this);
    }

    handleCtaClick(orderType, row) {
      const positionEntryProps = {};
      positionEntryProps.type = orderType;
      positionEntryProps.assetId = row.number;
      positionEntryProps.isPositionEntry = true;
      positionEntryProps.posId = row.secID;
      // TODO: this field might be removed in future once quantity implementation is confirmed
      positionEntryProps.quantityHeld = row.quantity;
      positionEntryProps.selectedPortfolio = this.props.app.user.selectedPortfolio;
      this.props.setComponentProps(positionEntryProps);
      this.props.setInitialPath(ROUTES.TRADE.NEW_ORDER);
      this.props.changePage(ROUTES.TRADE.LIBRARY);
    }

    handlePageChange() {
      this.setState({ activeItems: [] });
      this.rootView.handleScrollTo(0);
    }

    // closeModal = () => {
    //   this.props.trade.resetBlurModalError();
    // }

    componentDidMount() {
      this.props.changeStateTitle({ custometitle: this.props.portfolio.selectedAssetDesc });
      const myAssetList = this.props.portfolio.assetlist;
      this.props.payments.setDisableTabs(false);  //WMCE-41840-To Enable Menu bar on pressing back of browser
      if (myAssetList == null, myAssetList.length == 0) {
        this.props.getmyassetlist();
      }
    }
    componentWillUnmount() {
      this.props.changeStateTitle({ custometitle: "" });
    }
    render() {
      const { portfolio, ui, search, screen, i18n: { messages }, auth } = this.props;

      const width = Dimensions.get('window').width;
          if(width > 500 && width < 1000){
            this.setState({ widthClassForZoom : true });
          }
          if(width > 1000){
            this.setState({ widthClassForZoom : false });
          }

      selectedFirstLevelAsset = portfolio.assetClassName;
      const assetData = portfolio[assetCategory];
      const uiStatic = assetData.static;
      const uiState = assetData.state;
      const uiSortingState = ui.state.portfolio[assetCategory];
      const referenceCurrency = portfolio.referenceCurrency;
      const assetNames = portfolio.assetNames != null ? portfolio.assetNames : [];
      // const rows = assetData.positionsSorted.filter(row => {
      //   if (search.filter.positionId !== null) {
      //     return row.security.id === search.filter.positionId;
      //   } else {
      //     return row;
      //   }
      // });
      const isFiltered = search.filter.positionId !== null;
      let rows = [];
      if (isFiltered) {
        rows = [assetData.positionsByPosId];
      } else {
        rows = assetData.positionsSorted;
      }
      const myAssetList = portfolio.assetlist;
      if (myAssetList == null, myAssetList.length == 0) {
        this.props.getmyassetlist();
      }
      const assetList = portfolio.assetlist;

      const selectedAsset = assetList.find(x => x.assetShortDesc == selectedFirstLevelAsset);
      let marketDataValue = {};
      if (selectedAsset != undefined) {
        marketDataValue = {
          asOfDate: selectedAsset.asOfDate,
          dayChange: {
            percent: selectedAsset.mktDayChgPct,
            value: selectedAsset.mktDayChg,
          },
          marketValue: {
            value: selectedAsset.mktValue,
          }
        };
      } else {
        marketDataValue = {
          dayChange: {
            percent: '',
            value: '',
          },
          marketValue: {
            value: '',
          }
        };
      };
      const assetPositions = assetData[positionsProp];
      return (
        <div className='asset-positions row'>
          {!screen.isSmall &&
            <div className="stick-header"><NavigationBar assetList={assetList} assetNames={assetNames} messages={messages} setPageOffset={assetPositions.setPageOffset} resetSort={uiSortingState.resetSort} /></div>
          }
          <HeaderComponent isPopoverRequired={false} currency={referenceCurrency} messages={messages} marketData={marketDataValue} location={ui.history.currentLocation.pathname} />
          <StickyContainer style={{ minHeight: screen.height / 2.4, marginTop: '5px', width:this.state.widthClassForZoom? '200%' : "" }}>
            <Sticky fixedTop={!screen.isSmall ? 127 : 80}>
              {
                ({ isSticky, wasSticky, style, distanceFromTop, distanceFromBottom, calculatedHeight }) => <Header style={style} assetCategory={assetCategory} inputs={this.props} messages={messages} />
              }
            </Sticky>
            <ScrollableLayout
              body={
                <View>
                  <AssetAccordion
                    ref={r => { this.rootView = r; }}
                    uiStatic={uiStatic}
                    state={uiState}
                    rows={rows}
                    messages={messages}
                    activeItems={this.state.activeItems}
                    renderRow={row => <RowComponent
                      row={row}
                      assetData={assetData}
                      assetGroupId={row.assetGroupId}
                      assetShortDesc={row.assetShortDesc}
                      assetCategory={assetCategory}
                      referenceCurrency={referenceCurrency}
                      selectedFirstLevelAsset={selectedFirstLevelAsset}
                      screen={screen}
                      langCode={this.props.auth.langCode}
                    />}
                    renderRowExpanded={(row) => <ExpandedRowComponent
                      uiStatic={uiStatic}
                      row={row}
                      messages={messages}
                      assetCategory={assetCategory}
                      assetShortDesc={row.assetShortDesc}
                      subAssetdetailsGroups={ui.static}
                      landscapeComponent={AssetPositionModal}
                      referenceCurrency={referenceCurrency}
                      abbreviationRules={ui.static.abbreviationRules}
                      screen={screen}
                      isPaymentAvailable={auth.isPaymentCheck}
                      paymentAvailableList={auth.paymentAvailableList}
                      isVascoActivated={auth.vascoActivated}
                      selectedPortfolio={this.props.app.user.selectedPortfolio}
                      handleCtaClick={this.handleCtaClick}
                      entitledForTrading={this.props.auth.entitlements.trading}
                      langCode={this.props.auth.langCode}
                      tradeSecurity={this.props.positionEntry && this.props.positionEntry.trade}
                      showSpinner={this.props.ui.positions.transactions.moveToTransactions.showSpinner}
                    />}
                    footer={
                      <View>
                        <AbbreviatedNotes />
                        {
                          !isFiltered &&
                          <Pagination
                            pageOffset={assetPositions.pageOffset}
                            pageSize={assetPositions.pageSize}
                            totalRecords={assetPositions.length}
                            setPageOffset={assetPositions.setPageOffset}
                            onPageChange={this.handlePageChange}
                            style={{ marginVertical: 20 }} />
                            
                        }
                      </View>
                    }
                  />
                </View>
              } />
          </StickyContainer>
        </div>
      );
    }
  }

  AssetPositions.propTypes = {
    portfolio: PropTypes.shape({
      referenceCurrency: PropTypes.string,
      [assetCategory]: PropTypes.object,
    }),
    ui: PropTypes.object,
  };

  AssetPositions.displayName = `${capitalize(assetCategory)}AssetPositions`;

  return createContainer({
    $renderError: () => <Error />,
    $renderLoading: () => <LoadingCircle isPage />,
    $queries: {
      changePage: { $call: 'ui.history.push' },
      auth: {
        isPaymentCheck: true,
        paymentAvailableList: true,
        vascoActivated: true,
        entitlements: {
          trading: true
        },
        langCode: true
      },
      app: {
        user: {
          selectedPortfolio: true,
        }
      },
      setComponentProps: { $set: 'ui.componentProps' },
      setInitialPath: { $set: 'ui.component.initialPath' },
      getmyassetlist: { $call: 'portfolio.getmyassetlist' },
      positionEntry: {
        trade: { security: true }
      },
      portfolio: {
        assetClassName: true,
        referenceCurrency: true,
        assetNames: true,
        assetlist: true,
        // assetsSorted: {
        //   $type: 'list',
        //   $range: {
        //     offset: 0,
        //     length: ref('portfolio.assets.length'),
        //   },
        //   $node: {
        //     category: {
        //       id: true,
        //       name: true,
        //     },
        //     allocation: {
        //       value: true,
        //     },
        //     marketValue: {
        //       value: true,
        //     },
        //     dayChange: {
        //       percent: true,
        //       value: true,
        //     },
        //   },
        // },
        // selectedAssetObj: true,
        selectedAssetDesc: true,
        [assetCategory]: {
          // ...HeaderComponent.getFragment('assetData'),
          ...RowComponent.getFragment('assetData'),
          static: {
            ...SortingHeaderComponent.getFragment('uiStatic'),
            ...AssetAccordion.getFragment('uiStatic'),
            ...ExpandedRowComponent.getFragment('uiStatic'),
          },
          state: {
            ...AssetAccordion.getFragment('state'),
          },
          positionsByPosId: {
            isin: true,
            secID: true,
            name: true,
            ...RowComponent.getFragment('row'),
            ...ExpandedRowComponent.getFragment('row'),
          },
          positionsSorted: {
            $type: 'list',
            $range: {
              offset: ref(`portfolio.${assetCategory}.${positionsProp}.pageOffset`),
              length: ref(`portfolio.${assetCategory}.${positionsProp}.pageSize`),
            },
            // TODO defer
            // $node: defer({
            $node: {
              // commented for future reference
              // isin: true, // TODO: remove when DGUI-948 is fixed
              // assetGroupId: true,
              // assetShortDesc: true,
              // secID: true,
              // name: true,
              ...RowComponent.getFragment('row'),
              ...ExpandedRowComponent.getFragment('row'),
            },
          },
          [positionsProp]: {
            length: true,
            pageSize: true,
            pageOffset: true,
            setPageOffset: { $set: 'pageOffset' },
          },
        },
      },
      i18n: {
        messages: true,
      },
      changeStateTitle: { $call: 'ui.change.customtitle' },
      ui: {
        history: {
          currentLocation: {
            pathname: true
          }
        },
        positions: {
          transactions: {
            moveToTransactions: {
              showSpinner: true
            }
          }
        },
        static: {
          abbreviationRules: true,
          [assetCategory]: {
            cashGroups: {
              detailsGroups: true,
            },
            mmDepositesGroups: {
              detailsGroups: true,
            },
            fundsGroups: {
              detailsGroups: true,
            },
            optionsGroups: {
              detailsGroups: true,
            },
            othersGroups: {
              detailsGroups: true,
            },
            structuredProductsGroups: {
              detailsGroups: true,
            },
            creditGroups: {
              detailsGroups: true,
            },
            limitGroups: {
              detailsGroups: true,
            },
            bondsGroups: {
              detailsGroups: true,
            },
            sharesGroups: {
              detailsGroups: true,
            },
            futuresGroups: {
              detailsGroups: true,
            },
            swapsGroups: {
              detailsGroups: true,
            },
            commoditiesGroups: {
              detailsGroups: true,
            },
            insurancePoliciesGroups: {
              detailsGroups: true,
            },
            pawnGroups: {
              detailsGroups: true,
            },
            propertyGroups: {
              detailsGroups: true,
            },
          },
        },
        state: {
          portfolio: {
            [assetCategory]: {
              ...SortingHeaderComponent.getFragment('state'),
              resetSort: { $call: 'resetSort' },
            }
          },
        },
      },
      search: {
        filter: {
          positionId: true,
        },
      },
      screen: {
        width: true,
        height: true,
        isSmall: true,
      },
      payments: {
      disableTabs:true,
      setDisableTabs: { $set: 'disableTabs'},
      },

    },
  })(AssetPositions);
}
